module.exports = __webpack_public_path__ + "img/hot-dish.ef8d9a97.svg";